import React from 'react' // eslint-disable-line no-unused-vars

class DocumentsCart extends React.Component {
  constructor (props) {
    super(props)
    this.DOCS_PER_PAGE = 4
    this.cart = [[]]
    this.state = {
      currentPage: 0
    }
  }

  componentWillReceiveProps (props) {
    this.cart = this.paginate(props.cart)
    if (this.cart.length === this.state.currentPage) {
      this.setState(state => {
        return { currentPage: state.currentPage - 1 }
      })
    }
  }

  handlePageForward = () => {
    this.setState(prevState => ({
      currentPage:
        prevState.currentPage === this.cart.length - 1
          ? prevState.currentPage
          : prevState.currentPage + 1
    }))
  };

  handlePageBackward = () => {
    this.setState(prevState => ({
      currentPage: prevState.currentPage === 0 ? 0 : prevState.currentPage - 1
    }))
  };

  paginate = cart => {
    if (cart.length <= this.DOCS_PER_PAGE) {
      return [cart]
    }
    const sorted = []
    let intermediateArr = []
    let i = 0
    for (const idx in cart) {
      intermediateArr.push(cart[idx])
      if (i === this.DOCS_PER_PAGE - 1) {
        sorted.push(intermediateArr)
        i = 0
        intermediateArr = []
      } else {
        i++
      }
    }
    intermediateArr.length !== 0 && sorted.push(intermediateArr)
    return sorted
  };

  render () {
    return (
      <div id='doc-cart-container'>
        <h1 className='title'>{`Documents to be shared${
          this.props.cart.length === 0
            ? ''
            : ' (' + this.props.cart.length + ')'
        }:`}
        </h1>
        {this.props.cart.length === 0 ? (
          'Select documents from the table above.'
        ) : (
          <div>
            {this.cart.length > 1 && (
              <div className='page-indicator'>{`Displaying ${
                this.cart[this.state.currentPage].length
              } of ${this.props.cart.length} documents`}
              </div>
            )}
            <span
              className={`page-left fa fa-angle-left${
                this.state.currentPage !== 0 ? ' active' : ''
              }`}
              onClick={this.handlePageBackward}
            />
            <CartItems
              documents={this.props.documents}
              cart={this.cart[this.state.currentPage]}
              onCart={this.props.handleCart}
            />
            <span
              className={`page-right fa fa-angle-right${
                this.state.currentPage !== this.cart.length - 1 ? ' active' : ''
              }`}
              onClick={this.handlePageForward}
            />
          </div>
        )}
      </div>
    )
  }
}

function CartItems (props) {
  const items = props.cart.map((documentNumber, index) => {
    if (index < 4) {
      return (
        <div
          className={`cart-item col-3 ${index === 3 ? 'last' : ''}`}
          key={documentNumber}
        >
          <div id={documentNumber} className='doc-name'>
            {`${
              props.documents.find(document => {
                return document.number === documentNumber
              }).name
            } `}
          </div>
          <span className='added'>
            <span className='fa fa-check' />
            Added
          </span>
          <span
            id={`remove-${documentNumber}`}
            className='remove'
            onClick={() => {
              props.onCart(documentNumber)
            }}
          >
            Remove
          </span>
        </div>
      )
    } else {
      return null
    }
  })
  return <div className='row'>{items}</div>
}

export default DocumentsCart



// WEBPACK FOOTER //
// ./src/mi-app/submitInquiry/DocumentsCart.js